import { c as _c } from "react/compiler-runtime";
import type { InterestSaveMemberFilterRequest } from '__generated__/api/auth';
import { useToast } from '@common/hooks';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { usePathname } from 'next/navigation';
import { AuthApi } from '@/api';
import { queryKeys } from '@/constants/query-keys';
type PostBasicFilterDataParams = Omit<InterestSaveMemberFilterRequest, 'welloMemberFamilyId'>;
interface UseGetInterestedPolicyFilterDataQueryParams {
  onSuccess?: () => void;
}
export const usePostInterestedFilterDataMutation = params => {
  const $ = _c(10);
  const {
    toast,
    toastError
  } = useToast();
  const queryClient = useQueryClient();
  const pathname = usePathname();
  let t0;
  if ($[0] !== params || $[1] !== pathname || $[2] !== queryClient || $[3] !== toast) {
    t0 = async () => {
      await queryClient.invalidateQueries({
        queryKey: [queryKeys.myInterestedPolicyFilter]
      });
      if (pathname?.includes("/join")) {
        toast({
          message: "\uD68C\uC6D0\uAC00\uC785\uC774 \uC644\uB8CC\uB418\uC5C8\uC2B5\uB2C8\uB2E4."
        });
      } else {
        toast({
          message: "\uC800\uC7A5\uB418\uC5C8\uC2B5\uB2C8\uB2E4."
        });
      }
      params?.onSuccess?.();
    };
    $[0] = params;
    $[1] = pathname;
    $[2] = queryClient;
    $[3] = toast;
    $[4] = t0;
  } else {
    t0 = $[4];
  }
  let t1;
  if ($[5] !== toastError) {
    t1 = error => toastError({
      error
    });
    $[5] = toastError;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  let t2;
  if ($[7] !== t0 || $[8] !== t1) {
    t2 = {
      mutationFn: _temp,
      onSuccess: t0,
      onError: t1
    };
    $[7] = t0;
    $[8] = t1;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  return useMutation(t2);
};
function _temp(requestBody) {
  return AuthApi["post:/wello/v2/auth/member-filter/interest"]({
    body: requestBody
  });
}